import React from "react";

const LogoSVGComponent = (props) => (
    // <svg
    //   width="257.000000pt"
    //   height="214.000000pt"
    //   viewBox="0 0 257.000000 214.000000"
    //   preserveAspectRatio="xMidYMid meet"
    //   {...props}
    // >
    //   <metadata>
    //     {"\n    Created by CRMBot Ltd\n  "}
    //   </metadata>
    //   <g
    //     transform="translate(0.000000,214.000000) scale(0.100000,-0.100000)"
    //     fill="#000000"
    //     stroke="none"
    //   />
    // </svg>
    <svg
        viewBox="1099.295 0 260.131 225.6"
        style={{
            enableBackground: "new 0 0 1534 225.6",
        }}
        {...props}
    >
        <defs>
            <style type="text/css">{"\n\t.st0{fill:#FFFFFF;}\n"}</style>
        </defs>
        <g>
            <path
                className="st0"
                d="M25.3,26.8C8.4,42.8,0,64,0,90.2c0,26.4,8.5,48.3,25.6,65.6s38.6,26,64.6,26h101.2v-31.2H90.2 c-17.1,0-31.3-5.3-42.4-16C36.8,123.9,31.2,110,31.2,92.8c0-17.3,5.5-31.5,16.7-42.5c11.1-11,25.2-16.5,42.4-16.5h101.2V2.6H90.2 C63.8,2.6,42.2,10.7,25.3,26.8z"
            />
            <path
                className="st0"
                d="M423,106.5c9.4-10.8,14.2-23.8,14.2-38.8c0-22-8.1-38.7-24.4-50.1C398.6,7.6,380,2.6,356.9,2.6H228.4v179.1 h31.2V33.8h102.3c28.3,0,42.5,11.2,42.5,33.6c0,11-4.5,19.5-13.4,25.4c-7.9,5.1-17.6,7.6-29.1,7.6H278v30.9h67.4l50.1,50.4h46.2 l-54.3-54C402.4,123.7,414.3,116.6,423,106.5z"
            />
            <path
                className="st0"
                d="M701.8,5.5c-3.8-3.7-8-5.5-12.6-5.5c-6.8,0-13.3,5.9-19.4,17.6l-60.1,117.2L549.9,17.6 C543.8,5.9,537.4,0,530.5,0c-4.7,0-8.9,1.7-12.5,5.2c-3.6,3.5-5.9,7.6-6.9,12.3L471,182h35.4l25.7-125.4L592.2,172 c4.2,8,10.3,12.1,18.4,12.1c7.2,0,12.8-3.9,16.8-11.8l60.1-115.7l26,125.4h35.1L708.6,17.6C707.4,12.9,705.1,8.8,701.8,5.5z"
            />
            <path
                className="st0"
                d="M1085.3,55.6c0-8.7-2.4-17-7.1-24.7c-12.2-19.1-33.7-28.6-64.3-28.6H885.4v179.1h128.5 c32.2,0,54-10.1,65.6-30.2c3.8-6.8,5.8-14.1,5.8-21.8c0-14.5-6.3-26.7-18.9-36.5C1079,83,1085.3,70.5,1085.3,55.6z M1018.7,108.8 c8.4,0,16,1.4,22.8,4.2c9.1,3.8,13.6,9.4,13.6,16.8c0,7.2-4.5,12.7-13.6,16.5c-6.6,2.6-14.3,3.9-22.8,3.9h-102V33.6h102 c8.7,0,16.5,1.5,23.3,4.5c8.7,4,13.1,9.8,13.1,17.3c0,7.7-4.4,13.6-13.1,17.6c-6.8,3.1-14.6,4.7-23.3,4.7H935v31.2H1018.7z"
            />
            <path
                className="st0"
                d="M1266.4,2.6H1196c-26.4,0-48,8-64.9,24.1c-16.9,16.1-25.3,37.2-25.3,63.5c0,26.4,8.5,48.3,25.6,65.6 c7.2,7.3,15.2,13,24,17.3l-9,52.5l79.1-43.9h41c26.2,0,47.8-8.7,64.8-26c17-17.3,25.4-39.2,25.4-65.6c0-26.2-8.4-47.4-25.2-63.5 C1314.7,10.7,1293,2.6,1266.4,2.6z M1309,134.5c-11.1,10.7-25.3,16-42.6,16H1196c-17.1,0-31.3-5.3-42.4-16 c-11.1-10.7-16.7-24.6-16.7-41.7c0-17.3,5.5-31.5,16.7-42.5c11.1-11,25.2-16.5,42.4-16.5h70.5c17.3,0,31.5,5.5,42.6,16.5 c11.1,11,16.7,25.2,16.7,42.5C1325.7,110,1320.1,123.9,1309,134.5z"
            />
            <polygon
                className="st0"
                points="1361.7,2.6 1361.7,33.8 1432.5,33.8 1432.5,181.7 1463.5,181.7 1463.5,33.8 1534,33.8 1534,2.6 &#9;"
            />
            <ellipse
                transform="matrix(0.9239 -0.3827 0.3827 0.9239 55.4524 463.1442)"
                className="st0"
                cx={1191.9}
                cy={92.2}
                rx={18.8}
                ry={18.8}
            />
            <ellipse
                transform="matrix(0.9239 -0.3827 0.3827 0.9239 61.431 493.1996)"
                className="st0"
                cx={1270.5}
                cy={92.2}
                rx={18.8}
                ry={18.8}
            />
        </g>
    </svg>
);

export default LogoSVGComponent;